// Hooks
import { useEffect, useState } from 'react';

// Components
import Button from '../Button/Button';

const PlaybookPdf = (props) => {
  const { label, modifier, modal } = props;

  const [downloadReady, setDownloadReady] = useState(false);

  // Get slug for title
  const pathname = window.location.pathname.split('/');
  const slug = pathname.pop() || pathname.pop(); // handle potential trailing slash

  // Playbook rendered for use in Pdf
  const path = window.location.href.split('#')[0];
  const pageUrl = `${path}?download=pdf`;
  const ts = Math.floor(Date.now() / 1000);
  const token = process.env.LAMBDA_AUTH_TOKEN;

  const bindDownloadToButton = (blob, filename) => {
    setDownloadReady(true);
    const buttonLink = modal.current.querySelector('.ModalForm .Button-link');
    buttonLink.href = window.URL.createObjectURL(blob);
    buttonLink.download = filename;
    buttonLink.click();
  };

  const generatePdfBlob = () => {
    fetch(`/.netlify/functions/pdf`, {
      method: 'POST',
      headers: {
        Authorization: `Basic ${btoa(`${process.env.LAMBDA_AUTH_TOKEN}:`)}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        pageUrl,
        ts,
        token,
      }),
    }).then((response) => {
      response.blob().then((blob) => {
        bindDownloadToButton(blob, `Mutiny-Playbook--${slug}.pdf`);
      });
    });
  };

  // generate Pdf blob on load pdf on load
  useEffect(() => {
    if (typeof window !== 'undefined') {
      generatePdfBlob();
    }
  }, []);

  return (
    <>
      {!downloadReady && (
        <>
          <img className="ModalForm-image" src="/images/playbooks/modal_pdf_progress.gif" alt="loading" />
          <h2 className="ModalForm-title">Preparing your PDF...</h2>
        </>
      )}
      {downloadReady && (
        <>
          <img className="ModalForm-image" src="/images/playbooks/modal_pdf_ready.gif" alt="ready" />
          <h2 className="ModalForm-title">Your PDF is ready</h2>
          <span className="ModalForm-subtitle">Your download starts automatically. Didn't work?</span>
        </>
      )}

      <div className={`Button-wrapper ${downloadReady ? '' : 'is-disabled'}`}>
        <Button label={label} modifier={modifier} custom />
      </div>
    </>
  );
};

export default PlaybookPdf;
